import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("获取异常")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("生成凭证")
const _hoisted_5 = { style: {"font-size":"18px","color":"#000000"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定")

import { ref, provide, reactive, onBeforeMount, nextTick} from 'vue'
import {useRouter} from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { formatNumber, getNumber,exportHandle } from '@/utils/index'
import ProcuresPayment from "@/views/ViewsComponents/purchase/payment.vue"
import ProcuresSummary from "@/views/ViewsComponents/purchase/summary.vue"
import ProcuresStatistics from "@/views/ViewsComponents/purchase/ProcuresStatistics.vue"
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/order_profit/transaction/query': transactionApi,
  'POST/order_profit/inconsistent': inconsistentApi,
  // 生成凭证记录
  'POST/order_profit/generate_voucher': generate_voucherApi,
  // 双击公司金额导出
  'POST/order_profit/export_costOrder': export_costOrderApi,
  // 发票主体全部公司列表
  'GET/companies/en_name/list': companiesFullEn_nameApi,
  // 成本公司
  'GET/rt/company/list':companyListApi,
} = Api

const activeName = ref('1')
const paymentEle = ref()
const switchTabHandle = (params: object) =>{
  activeName.value = '2'
  nextTick(() => {
    paymentEle.value.queryInfo = params
    paymentEle.value.searchHandle()

  })
}

const router = useRouter()


const invoiceCompanyList = ref<any>([])
const companyList=ref<any>([])
onBeforeMount(() => {
  companiesFullEn_nameApi().then((rep: any) => {
    invoiceCompanyList.value = rep.enName
  })
  companyListApi().then((res:any)=>{
    companyList.value = res.company
  })
})
provide('invCompList',  invoiceCompanyList)
provide('companyList',  companyList)


const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(transactionApi)

const searchObj = reactive({
  deliverTime: [
    dayjs().startOf('year').format('YYYY-MM-DD'),
    dayjs().startOf('year').add(5, 'month').format('YYYY-MM-DD'),
  ],
  dataSourceType: '',
})

let totalObj: any = reactive({company: []})
const searchHandle = () => {
  fetchData({
    ...searchObj,
    deliverTime: {from: searchObj.deliverTime?.[0], to: searchObj.deliverTime?.[1]},
  }).then((companys: any) => {
    // 获取所有被转账公司
    Object.assign(totalObj, companys.total)
    // console.log(companys.total);
    
    /* let columnCompanys = companys.data.reduce((arr: string[], com: any) => {
      let companyArr = com.company.flatMap((e: any) => e.name).filter((item: string) => item)
      return Array.from(new Set([...arr, ...companyArr]))
    }, [])
    columns.value = columnCompanys */
  })
}

// 获取对应公司金额
const foramtColumn = (row: any, companyStr: string) => {
  let obj = row.company.find((company: {name: string}) => company.name === companyStr)
  return obj ? getNumber(obj.amount) : '-'
}

// 跳转
// const switchPageHandle = (row: any, column: any) => {
//   if(column.property === 'alias') return;
//   router.push({ 
//     path: '/rt', 
//     query: {
//       company: column.label,
//       companyId: row.companyId,
//       deliverTimeFrom: MI_params.deliverTime.from,
//       deliverTimeTo: dayjs(MI_params.deliverTime.to).endOf('month').format('YYYY-MM-DD'),
//       isNoCalculated: 'false',
//       existTestCost: 'false',
//     }
//   })
// }

const cellExportHandle=(row:any, column:any, cell:any, event:any)=>{
  let label=column.label
  let idx:any=totalObj.company.findIndex((el:any)=>el.name==label)
  console.log(idx)
  if(idx==-1){ //点击公司以外的单元格不做出反应
    return
  }
  let company:any=row.company
  let res=company.find((el:any)=>el.name==label)
  if(!res||!res.amount){ //不包含公司或没有金额数据的不导出
    ElMessage.warning('暂无数据')
    return
  }
  let params={
    key:"Cost",
    ids:res.costIds,
    coNoList:[]
  }
  exportHandle(export_costOrderApi,params)
}

// 获取异常
const isShowAbnormal = ref<boolean>(false)
let abnormalArr = ref<string[]>([])
const getAbnormal = () => {
  if(!MI_params.deliverTime?.from && !MI_params.deliverTime?.from){
    ElMessage.warning('请先搜索日期')
    return
  }
  inconsistentApi({
    deliverTime: MI_params.deliverTime
  }).then((rep: any) => {
    abnormalArr.value = rep.noList
    isShowAbnormal.value = true
  })
}

// 生成凭证
const isShowVoucher = ref<boolean>(false)
const voucherEle = ref()
const isBtnLoad = ref<boolean>(false)
const voucherObj = reactive({
  deliverTime: [], voucherSource: 'INTERNAL', dataSourceType: '',
})
const generateVoucher = () => {
  if(voucherObj.deliverTime?.length !== 2 || !voucherObj.dataSourceType){
    ElMessage.warning('请选择交付时间或数据筛选')
    return
  }
  isBtnLoad.value = true
  generate_voucherApi({
    ...voucherObj,
    deliverTime: {
      from: voucherObj.deliverTime?.[0],
      to: voucherObj.deliverTime?.[1],
    }
  }).then(() => {
    ElMessage.success('成功生成凭证')
    isShowVoucher.value = false
  }).finally(() => {
    isBtnLoad.value = false
  })
}

// -----------------
const getSummaries = (param: any) => {
  const { columns, data } = param
  let sums: string[] = ['合计']
  totalObj.company.map((dynamicCom: any, index: number) => [
    sums[index + 1] = getNumber(dynamicCom.amount)
  ])
  columns.forEach((column: {property: string}, index: number) => {
    if(index === 0) return;
    if(!column.property.includes(".")) return;

    let property = column.property.split(".")
    sums[index] = getNumber(totalObj?.[property[0]]?.[property[1]])
  })

  return sums
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "内部交易-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "formRef",
              model: _unref(searchObj),
              class: "searchBg",
              inline: "",
              disabled: _unref(MI_identify)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "日期:",
                  prop: "deliverTime"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).deliverTime,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).deliverTime) = $event)),
                      type: "monthrange",
                      style: {"width":"330px"},
                      "value-format": "YYYY-MM-DD",
                      clearable: false,
                      "range-separator": "至",
                      "start-placeholder": "开始月份",
                      "end-placeholder": "结束月份"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "数据筛选:",
                  prop: "dataSourceType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).dataSourceType,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).dataSourceType) = $event)),
                      placeholder: "请选择数据筛选",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "全部",
                          value: "全部"
                        }),
                        _createVNode(_component_el_option, {
                          label: "排除co2",
                          value: "排除co2"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (searchHandle())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[3] || (_cache[3] = () => {})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      type: "danger",
      onClick: getAbnormal,
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_button, {
      onClick: _cache[4] || (_cache[4] = ($event: any) => (isShowVoucher.value = true)),
      type: "primary",
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mt-10",
      border: "",
      data: _unref(MI_tableData),
      "show-summary": "",
      "summary-method": getSummaries,
      onCellDblclick: cellExportHandle,
      "max-height": _unref(MI_height)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "alias",
          width: "120",
          fixed: "",
          "show-overflow-tooltip": ""
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(totalObj).company, (company) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            label: company.name,
            prop: company.name,
            "show-overflow-tooltip": "",
            align: "right",
            formatter: (row) => foramtColumn(row, company.name)
          }, null, 8, ["label", "prop", "formatter"]))
        }), 256)),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "CCJK HK",
          prop: "agencyCompany.agencyHK"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "昆仲",
          prop: "agencyCompany.agencyKZ"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "国内公司应付昆仲成本",
          prop: "domesticData.domesticKZPayable",
          width: "170"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "增值税",
          prop: "domesticData.vatAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "昆仲应收国内",
          prop: "domesticData.domesticKZReceivable"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "国内转昆仲付香港成本",
          prop: "abroadHKData.payableAmount",
          width: "170"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "增值税",
          prop: "abroadHKData.vatAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "昆仲收",
          prop: "abroadHKData.receivableKZAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "昆仲转付香港",
          prop: "abroadHKData.changeTotalAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "香港收",
          prop: "abroadHKData.receivableHKAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "昆仲应付香港",
          prop: "payableHKFromKZ.payableAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "香港收",
          prop: "payableHKFromKZ.receivableAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "国外应付香港",
          prop: "payableHKFromAbroad.payableAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "香港收",
          prop: "payableHKFromAbroad.receivableAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "国外转香港付昆仲",
          prop: "abroadKZData.payableAmount",
          width: "170"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "香港收",
          prop: "abroadKZData.receivableHKAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "香港转昆仲",
          prop: "abroadKZData.changeTotalAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "昆仲收",
          prop: "abroadKZData.receivableKZAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "香港应付昆仲",
          prop: "payableKZFromHK.payableAmount"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          label: "昆仲收",
          prop: "payableKZFromHK.receivableAmount"
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      title: "异常订单号",
      modelValue: isShowAbnormal.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isShowAbnormal).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(abnormalArr).length > 0 ? _unref(abnormalArr).join(',') : '无异常'), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowVoucher.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((isShowVoucher).value = $event)),
      title: "生成凭证",
      onClose: _cache[12] || (_cache[12] = ($event: any) => (voucherEle.value.resetFields()))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (isShowVoucher.value = false)),
          disabled: isBtnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (generateVoucher())),
          loading: isBtnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "voucherEle",
          ref: voucherEle,
          model: _unref(voucherObj),
          "label-position": "top",
          inline: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "交付时间:",
              prop: "deliverTime",
              rules: [{required: true, message: '请选择交付时间', trigger: 'change'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  clearable: false,
                  "start-placeholder": "请选开始时间",
                  "end-placeholder": "请选结束时间",
                  modelValue: _unref(voucherObj).deliverTime,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(voucherObj).deliverTime) = $event)),
                  "value-format": "YYYY-MM-DD",
                  "range-separator": "至",
                  type: "daterange",
                  placeholder: "请选择交付时间"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "来源:",
              prop: "voucherSource",
              rules: [{required: true, message: '请选择来源', trigger: 'change'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(voucherObj).voucherSource,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(voucherObj).voucherSource) = $event)),
                  placeholder: "请选择来源"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "内部",
                      value: "INTERNAL"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "数据筛选:",
              prop: "dataSourceType",
              rules: [{required: true, message: '请选择数据筛选', trigger: 'change'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(voucherObj).dataSourceType,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(voucherObj).dataSourceType) = $event)),
                  placeholder: "请数据筛选"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "全部",
                      value: "全部"
                    }),
                    _createVNode(_component_el_option, {
                      label: "排除co2",
                      value: "排除co2"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})